import { ChangeEmailConfirmation } from "components/changeEmail/ChangeEmailConfirmation/ChangeEmailConfirmation";
import { Logout } from "components/common/Auth/Logout";
import { AuthBoundary } from "components/common/AuthBoundary/AuthBoundary";
import { Home } from "components/common/Home/Home";
import { MyAccountFooter } from "components/common/MyAccountFooter/MyAccountFooter";
import { MyAccountHeader } from "components/common/MyAccountHeader/MyAccountHeader";
import { DeleteAccountConfirmation } from "components/deleteAccount/DeleteAccountConfirmation/DeleteAccountConfirmation";
import { ChangeEmailError, DeleteAccountError } from "components/settings/SettingsError/SettingsError";
import { useLocalisedDocumentTitle } from "components/_hooks/useLocalisedDocumentTitle";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { routes } from "routes";

const WithHeaderFooter = () => {
  return (
    <>
      <MyAccountHeader isAuthenticated={true} /> {/* Always authenticated because inside AuthBoundary  */}
      <Switch>
        <Route path={routes.deleteAccountError} component={DeleteAccountError} />
        <Route path={routes.changeEmailError} component={ChangeEmailError} />
        <Route component={Home} />
      </Switch>
      <MyAccountFooter />
    </>
  );
};

export const AuthenticatedApp = () => {
  useLocalisedDocumentTitle();
  return (
    <AuthBoundary>
      <Switch>
        {/* Authenticated but without the header and footer  */}
        <Route path={routes.deleteAccountConfirmation} component={DeleteAccountConfirmation} />
        <Route path={routes.changeEmailConfirmation} component={ChangeEmailConfirmation} />
        <Route path={routes.logout} component={Logout} />

        {/* Authenticated with header and footer  */}
        <Route component={WithHeaderFooter} />
      </Switch>
    </AuthBoundary>
  );
};

export default AuthenticatedApp;
